/* eslint-disable no-undef */
export default {
	name: "create-collection-order-modal",
	props: ["heading", "modalId", "showModal", "customer"],
	emits: ["placeOrderOkClicked"],
	data() {
		return {
			company: {},
			customerShippingAddress: {},
			depots: [],
			vehicles: [],
			orderValidationRulesResults: [],
			order:{
				products:[],
				productsHasError: false,
				productsErrorMessage: null,
				customerPurchaseOrderNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				manifestNumber:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				depotId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				notes: null,
				totalAmount: 0,
				discountedAmount: 0
			},
			orderTypeId: orderHelper.orderType.collection,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			productFilter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			showWarningMessage: false,
			warningMessage: null,
			loading: false,
			hasError: false
		};
	},
	methods: {
		onProductSelected(products){
			console.log("products", products);
			this.order.products = [];
			this.order.totalAmount = 0;
			this.order.discountedAmount = 0;
			this.hasError = products.hasError;
			if(!products.hasError){
				for(let i = 0; i < products.selectedProducts.length; i++){
					var obj = JSON.parse( JSON.stringify( products.selectedProducts[i] ) );
					console.log("selectedProducts", obj);
					let itemToOrder = {
						productId: obj.productId,
						quantity: obj.quantity,
						totalPrice: obj.total,
						unitPrice: obj.price,
						// discountedAmount: obj.discountedAmountTotal
						discountedAmount: obj.discountAmount === null ? 0 : obj.discountAmount
					};
					this.order.products.push(itemToOrder);
					this.order.totalAmount += obj.total;
					this.order.discountedAmount += obj.discountedAmountTotal;
				}
			}
			
			console.log("order create", this.order);
		},
		getDepots(){
			this.loading = true;
			let request = {
				isActive: true,
				provinceId: 0
			};
			systemService.getAllDepots(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depots = successResponse.data.result;
						this.depots = $.map(this.depots,
							function (obj) {
								obj.id = obj.id || obj.depotId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.depots = dataTableHelper.castFieldValues(this.depots);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerVehicles() {
			let request = {
				companyId: this.company.companyId,
				isActive: true
			};
			customerService.getCompanyVehicles(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.vehicles = successResponse.data.result;
						this.vehicles = $.map(this.vehicles,
							function (obj) {
								obj.id = obj.id || obj.vehicleId;
								obj.text = obj.text || obj.make + " " + obj.model + " (" + obj.vehicleRegistration + " - " + obj.fleetNumber + ")";
								return obj;
							});
						this.vehicles = dataTableHelper.castFieldValues(this.vehicles);
						if(this.vehicles === null || this.vehicles.length === 0){
							this.showWarningMessage = true;
							this.warningMessage = "No vehicles found for customer, " + this.company.registeredCompanyName + ". Please add a vehicle for this customer before placing an order.";
						}
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onVehicleSelect(vehicle){
			this.order.vehicleId.value = vehicle.id;
		},
		onDepotSelect(depot){
			this.order.depotId.value = depot.id;
		},
		clearMessageAlerts(){
			this.clearModel();
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;

			this.$emit("placeOrderOkClicked", true);
		},
		onModalCloseClick() {
			this.clearModel();
			this.$emit("placeOrderOkClicked", true);
		},
		onModalSaveClick(){
			console.log("hasError", this.hasError);
			if(this.hasError){
				this.loading = false;
				return;
			}
			
			//save changes
			this.loading = true;
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;
			console.log("this.order.products", this.order.products);
			let request = {
				customerPurchaseOrderNumber: this.order.customerPurchaseOrderNumber.value,
				orderItems: this.order.products,
				//companyAddressId: this.order.shippingAddressId.value === null ? 0 : this.order.shippingAddressId.value,
				notes: this.order.notes,
				companyId: this.company.companyId,
				totalAmount: this.order.totalAmount,
				discountedAmount: this.order.discountedAmount,
				vehicleId: this.order.vehicleId.value == null ? 0 : this.order.vehicleId.value,
				depotId: this.order.depotId.value === null ? 0 : this.order.depotId.value,
				manifestNumber: this.order.manifestNumber.value
			};
			orderService.addOrUpdateCollectionOrder(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.collectionOrderValidationResponse.valuesAreValid){
							this.showSuccessMessage = true;
							this.successMessage = "Order saved successfully";
							this.clearModel();
						}
						else{
							this.order.productsHasError = successResponse.data.collectionOrderValidationResponse.itemsToOrderValidationResponse.hasError;
							this.order.productsErrorMessage = successResponse.data.collectionOrderValidationResponse.itemsToOrderValidationResponse.message;

							this.order.vehicleId.hasError = successResponse.data.collectionOrderValidationResponse.vehicleValidationResponse.hasError;
							this.order.vehicleId.errorMessage = successResponse.data.collectionOrderValidationResponse.vehicleValidationResponse.message;

							this.order.depotId.hasError = successResponse.data.collectionOrderValidationResponse.depotValidationResponse.hasError;
							this.order.depotId.errorMessage = successResponse.data.collectionOrderValidationResponse.depotValidationResponse.message;

							this.order.depotId.hasError = successResponse.data.collectionOrderValidationResponse.depotValidationResponse.hasError;
							this.order.depotId.errorMessage = successResponse.data.collectionOrderValidationResponse.depotValidationResponse.message;

							this.order.manifestNumber.hasError = successResponse.data.collectionOrderValidationResponse.manifestNumberValidationResponse.hasError;
							this.order.manifestNumber.errorMessage = successResponse.data.collectionOrderValidationResponse.manifestNumberValidationResponse.message;

							if(successResponse.data.collectionOrderValidationResponse.billingAddressValidationResponse !== null){
								this.showErrorMessage = successResponse.data.collectionOrderValidationResponse.billingAddressValidationResponse.hasError;
								this.errorMessage = successResponse.data.collectionOrderValidationResponse.billingAddressValidationResponse.message;
							}
							
							this.orderValidationRulesResults = successResponse.data.orderValidationResults;
							var modalContent = document.getElementById(this.modalId)
							if (modalContent) {
								modalContent.scrollTop = 0;
							}
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.showErrorMessage = true;
					this.errorMessage = errorResponse.response.data.message;
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearModel(){
			this.orderValidationRulesResults = [];
			this.order = {
				products:[],
				productsHasError: false,
				productsErrorMessage: null,
				customerPurchaseOrderNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				manifestNumber:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				depotId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				notes: null,
				totalAmount: 0,
				discountedAmount: 0
			};
		}
	},
	mounted: function () {
        this.orderTypeId = orderHelper.orderType.collection;
		this.getDepots();
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		customer:{
			handler: function (){
				console.log("customer", this.customer);
				if(this.customer !== null){
					this.company = this.customer;
					this.getCustomerVehicles();
				}
			}
		}
	}
};
